import { ForwardedRef, ReactNode, forwardRef } from 'react';
import styled from 'styled-components';

export const TextButton = forwardRef(
  (
    {
      children,
      handleClick,
      isActive,
      type,
    }: {
      children: ReactNode;
      handleClick?: (e: any) => void;
      isActive?: boolean;
      type?: 'info' | 'success' | 'warn' | 'error' | 'accent';
      key?: string;
    },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <Container ref={ref} active={isActive} type={type} onClick={handleClick}>
        {children}
      </Container>
    );
  }
);

const Container = styled.div<{
  active?: boolean;
  type?: 'info' | 'success' | 'warn' | 'error' | 'accent';
}>`
  user-select: none;
  position: relative;
  cursor: pointer;
  padding: 0 15px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 10px;
  height: 29px;

  font-size: 13px;
  color: var(--text-color-secondary);
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    color: var(--text-color);
    background-color: var(--panel-bg-color-hover);
  }

  &:active {
    color: var(--accent-color-secondary);
  }

  ${({ active }) =>
    active &&
    `
      color: var(--accent-color);
      background-color: var(--panel-bg-color-secondary);
  `}

  ${({ type }) =>
    type &&
    `
      color: var(--${type}-color);
      border: 1px solid var(--${type}-color);

      &:hover {
        color: var(--text-color);
        background-color: var(--${type}-color);
      }
  `}
`;
